import { render, staticRenderFns } from "./TestResizablePage.vue?vue&type=template&id=4b406d0a&"
import script from "./TestResizablePage.vue?vue&type=script&lang=js&"
export * from "./TestResizablePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports